import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=58611358&scoped=true&"
import script from "./PieChart.vue?vue&type=script&lang=ts&"
export * from "./PieChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58611358",
  null
  
)

export default component.exports